import styled from 'styled-components';
import TransparentButton from '@/trio-ui/TransparentButton';
import SearchInput from '../SearchInput';

export const AssignedUsersItem = styled.li`
  &:not(&:last-of-type) {
    margin-bottom: 4px;
  }
`;

export const AssignToMyselft = styled(TransparentButton)`
  margin-bottom: 12px;
`;

export const Box = styled.div`
  width: 100%;
`;

export const SearchArea = styled.div`
  position: relative;
  margin-bottom: 8px;
`;

export const SearchResults = styled.div`
  position: absolute;
  top: 65px;
  width: 100%;
  background: ${(props) => props.theme.colors['neutral-10']};
  border: 1px solid;
  border-color: ${(props) => props.theme.colors['neutral-30']};
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.07);
  z-index: 3;
`;

export const SearchResultItem = styled.li`
  &:hover {
    background: ${(props) => props.theme.colors['neutral-20']};
  }
  button {
    padding: 6px 12px;
    cursor: pointer;
    width: 100%;
  }
`;

export const NotFoundResults = styled.p`
  padding: 12px;
  font-size: 12px;
  text-align: center;
`;

export const InputLabel = styled.label`
  line-height: 19px;
  font-size: 14px;
  color: ${(props) => props.theme.colors['neutral-80']};
  margin-bottom: 2px;
  display: block;
`;

export const Input = styled(SearchInput)``;
